import { IconButton } from '@mui/material'
import React from 'react'
import ReactToPrint from '../../../Shared/print/ReactToPrint'


const TableListPrint = ({contentRef}) => {
  const handleBeforePrint = () => {
    // You could also scroll to the top of the table or ensure data is loaded.
    if (contentRef?.current) {
      contentRef.current.scrollTop = 0;  // Scroll to the top to ensure full data visibility
    }
  };
  return (
    <div className="justify-center" style={{ gap: "10px", width: "70%", justifyContent: "flex-end" }}>
    <ReactToPrint className="print-btn"
      trigger={() => (
        <IconButton title="Print" className="printer-div-list" style={{ color: "#fff", backgroundColor: "#002995", borderRadius: "0",height:"38px",width:"37px" }}>
          <i className="bi bi-printer"></i>
        </IconButton>
      )}
      content={() => contentRef?.current || null}  // Pass the content reference to print
      onBeforeGetContent={handleBeforePrint}
   />
  </div>
  )
}

export default TableListPrint